/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useCallback, useState } from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { ChartView } from '../../../molecules/ChartView';
import { DataTableRenderer } from '../DataTableRenderer';
import './ChartRendererStyles.scss';
export function ChartRenderer({ block }) {
    const chartBlock = block;
    const [showTable, setShowTable] = useState(false);
    const handleToggle = useCallback(() => {
        setShowTable((prev) => !prev);
    }, []);
    const canToggle = Boolean(chartBlock.toggle_table && chartBlock.table_data);
    const footerActions = canToggle
        ? [{ id: 'toggle', label: showTable ? 'Chart' : 'Table', icon: 'fa-light fa-table', onClick: handleToggle }]
        : [];
    return (React.createElement(AIGeneralBlockCard, { footerGroups: footerActions.length > 0 ? [{ actions: footerActions }] : [] }, showTable && chartBlock.table_data ? (React.createElement(DataTableRenderer, { block: chartBlock.table_data })) : (React.createElement(ChartView, { block: chartBlock }))));
}
